import React from 'react'
import { IconTypeProps } from '../icon';

export function IconArrow({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M9.68882 8.00003C9.68882 8.28678 9.57934 8.5735 9.36082 8.79212L2.4811 15.6718C2.04346 16.1094 1.33391 16.1094 0.896453 15.6718C0.458995 15.2343 0.458995 14.5249 0.896453 14.0872L6.98401 8.00003L0.896666 1.91279C0.459208 1.47516 0.459208 0.765821 0.896666 0.328398C1.33412 -0.10945 2.04368 -0.10945 2.48131 0.328398L9.36103 7.20794C9.57958 7.42667 9.68882 7.71339 9.68882 8.00003Z" />
    </svg>
  );
}
